import React, { Component } from 'react';


class Footer extends Component {
  render() {
    return (
      <div className="footer">
        <p className='b'>MNILI™ – Copyright University of Minnesota Board of Regents – All Rights Reserved</p>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.js